import React, { useState } from 'react';

import { Button } from 'components/bootstrap';
import { ConfirmDialog, IfPermitted } from 'components/common';
import { createGRN } from 'logic/permissions/GRN';
import useSelectedEntities from 'components/common/EntityDataTable/hooks/useSelectedEntities';
import type { Collection, CollectionEntity } from 'collections/types';
import useCollectionEntityMutation from 'collections/hooks/useCollectionEntityMutation';

type Props = {
  collectionId: Collection['id'];
  id: CollectionEntity['id'];
  name: CollectionEntity['name'];
  type: CollectionEntity['type'];
};

const CollectionEntityActions = ({ id, name, collectionId, type }: Props) => {
  const { deselectEntity } = useSelectedEntities();
  const { removeEntities } = useCollectionEntityMutation(collectionId);
  const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false);

  const cancelDelete = () => {
    setShowDeleteDialog(false);
    deselectEntity(id);
  };

  const handleDelete = () => {
    removeEntities({ removedEntities: [createGRN(type, id)] }).then(() => {
      deselectEntity(id);
      setShowDeleteDialog(false);
    });
  };

  const onDelete = () => {
    setShowDeleteDialog(true);
  };

  return (
    <>
      {showDeleteDialog && (
        <ConfirmDialog
          show={showDeleteDialog}
          title="Removing Content from Collection"
          onCancel={cancelDelete}
          onConfirm={handleDelete}>
          <p>You are about to remove &quot;{name}&quot; from the Collection. Are you sure?</p>
        </ConfirmDialog>
      )}
      <IfPermitted permissions={`collection_entities:edit:${collectionId}`}>
        <Button bsSize="xs" bsStyle="danger" onClick={onDelete}>
          Remove
        </Button>
      </IfPermitted>
    </>
  );
};

export default CollectionEntityActions;
